const DeactivateIcon = ({className}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      fill="none"
      viewBox="0 0 14 14"
      className={className}
    >
      <circle cx="7" cy="7" r="6" stroke="#42555E" strokeWidth="2"></circle>
      <path stroke="#42555E" strokeWidth="2" d="M7 4v6.5"></path>
    </svg>
  );
}

export default DeactivateIcon;